module.exports = __webpack_public_path__ + "static/media/bg_02.07721c70.jpg";